import ScrollToTop from "components/routes/ScrollToTop";
import { Routes } from "components/routes/Routes";
import "./App.scss";
import { useTranslationScript } from "hooks/useTranslationScript";
import { useMaintenanceMode } from "hooks/useMaintenanceMode";
import { LoadingOverlay } from "components/ui/loading-spinners";
import Maintenance from "pages/maintenance/Maintenance";

function App() {
  useTranslationScript();
  const { isMaintenanceMode, isLoading } = useMaintenanceMode();

  if (isLoading) {
    return (
      <div className="App">
        <LoadingOverlay />
      </div>
    );
  }

  if (isMaintenanceMode) {
    return (
      <div className="App">
        <Maintenance />
      </div>
    );
  }

  return (
    <div className="App">
      <ScrollToTop />
      <Routes />
    </div>
  );
}
export default App;
